module.exports = __webpack_public_path__ + "static/media/chatwidget-close.20bbb0d3.svg";